import useRentFrequency from "./useRentFrequency";

export * from "./useRentFrequency";
export default useRentFrequency;
